function isPopup(): boolean {
  return window.opener && window.opener !== window;
}

export default isPopup;
